import React, { useState, useEffect } from 'react';
import '../ImagePrompt.css';
import '../PreviewScreen.css';
import eyeSVG from '../Iconos/eye.svg';
import arrowSVG from '../Iconos/arrow.svg';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';

const VALID_MINUTES = 35;

const ReelPreviewScreen: React.FC = () => {
    const { t } = useTranslation();
    const [videoUrl, setVideoUrl] = useState<string | null>(null);
    const [coverImageUrl, setCoverImageUrl] = useState<string | null>(null);
    const [generatedText, setGeneratedText] = useState<string>('');
    const [currentSlide, setCurrentSlide] = useState(0); // Índice de la imagen/video actual

    useEffect(() => {
        const videoDataJSON = localStorage.getItem('selectedVideo');
        if (videoDataJSON) {
            const videoData = JSON.parse(videoDataJSON);
            const timeNow = new Date().getTime();
            const timeElapsed = (timeNow - videoData.timestamp) / 1000 / 60;

            if (timeElapsed < VALID_MINUTES) {
                setVideoUrl(videoData.video);
            } else {
                localStorage.removeItem('selectedVideo');
            }
        }

        const coverImageDataJSON = localStorage.getItem('selectedCoverImage');
        if (coverImageDataJSON) {
            const coverImageData = JSON.parse(coverImageDataJSON);
            setCoverImageUrl(coverImageData.imageUrl);
        }

        const textDataJSON = localStorage.getItem('textData');
        if (textDataJSON) {
            const textData = JSON.parse(textDataJSON);
            setGeneratedText(textData.content || '');
        }
    }, []);

    const handlePrevious = () => {
        if (currentSlide > 0) {
            setCurrentSlide(currentSlide - 1);
        }
    };

    const handleNext = () => {
        if (currentSlide < 1) { // Solo hay dos elementos, la portada y el video
            setCurrentSlide(currentSlide + 1);
        }
    };

    return (
        <div>
            <div className="preview-header">
                <img src={eyeSVG} alt="" /> <h2>{t('Vista Previa')}:</h2>
            </div>
            <div className="preview-container">
                <div className="main-image-container-distribution">
                    {coverImageUrl && currentSlide === 0 && (
                        <div className="preview-image-wrapper">
                            <img src={coverImageUrl} alt="Portada" className="preview-cover-image" />
                            <div className="flechas">
                               
                                <button className="image-nav-right" onClick={handleNext}>
                                    <img src={arrowSVG} alt="Next" className="normal-arrow" />
                                </button>
                            </div>
                        </div>
                    )}
                    {videoUrl && currentSlide === 1 && (
                        <div className="preview-video-wrapper">
                            <video controls src={videoUrl} className="preview-video" />
                            <div className="flechas">
                                <button className="image-nav-left" onClick={handlePrevious}>
                                    <img src={arrowSVG} alt="Previous" className="reverse-arrow" />
                                </button>
                            </div>
                        </div>
                    )}
                </div>
                {generatedText && (
                    <div className="preview-text">
                        <p>{generatedText}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ReelPreviewScreen;
